module.exports = __webpack_public_path__ + "google2.svg?b3daa61ad47e72f19717f95c04a33438";